import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faBook, faRightFromBracket, faUserCircle, faBars, faBarsStaggered } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Nav, NavItem, Collapse, Navbar, NavbarToggler, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import logoPath from "./../../assets/HPTILogo.png";
import { fetchPublicActiveEvent } from '../Services/Employees';
import './Header.css';

const Header = ({ isSidebarCollapsed, toggleSidebar, getPageTitle }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [logoutSuccess, setLogoutSuccess] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [bannerMessage, setBannerMessage] = useState('');

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  const handleLogout = () => {
    localStorage.removeItem('tokenId');
    localStorage.removeItem('UserName');
    setIsActive(true);
    navigate('/register');
    setLogoutSuccess(true);

    setTimeout(() => {
      setLogoutSuccess(false);
    }, 4000);
  };
  const loggedInUserName = localStorage.getItem('UserName');
  const loggedInToken = localStorage.getItem('tokenId');

  const location = useLocation();

  useEffect(() => {
    if (loggedInToken) {
      setBannerMessage('');
      return;
    }

    fetchPublicActiveEvent()
      .then((response) => {
        const data = response.data?.data;
        if (!data || !data.eventActive) {
          setBannerMessage('');
          return;
        }

        const eventName = data.event || '';

        // Admit card published for active event → show admit card line with exam date
        if (data.admitCardPublish) {
          const examDateText = data.examinationDateDisplay
            ? ` Exam date is ${data.examinationDateDisplay}.`
            : '';
          setBannerMessage(
            `Admit Card for ${eventName} Event is available in candidate's login.${examDateText}`
          );
          return;
        }

        // Event active (admit card not published) → show preference / center selection line
        const lastDateText = data.cutOffDateDisplay
          ? ` Last date to apply is ${data.cutOffDateDisplay}.`
          : '';
        setBannerMessage(
          `Exam and Center Selection Portal is open for ${eventName} Event.${lastDateText}`
        );
      })
      .catch(() => {
        setBannerMessage('');
      });
  }, [loggedInToken]);

  function handleRefresh() {
    navigate('/register');
    window.location.reload(false);
  }

  useEffect(() => {
    const loggedIn = localStorage.getItem('tokenId');
    const dashboardPaths = [
      "/dashboard", "/dashboard/centreselect", "/dashboard/employeeDashboard",
      "/dashboard/selectedexam", "/dashboard/admitcard", "/dashboard/result", "/dashboard/uploadAllocation", "/dashboard/uploadResult", "/dashboard/uploadNotice", "/dashboard/event"
    ];
    if (dashboardPaths.includes(location.pathname) && loggedIn) {
      setIsActive(false);
    }
  }, [location]);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="Header-container" style={{ borderBottom: '1px solid #4fa6ca', backgroundColor: "white" }}>
        <div className="header-content">

          <Row className="align-items-center">
            <Col className="text-center" md={1} xs={12}>
              <Link to="#">
                <img src={logoPath} style={{ height: 70 }} alt="logo" />
              </Link>
            </Col>

            <Col className="pt-4 mvl d-flex" md={5} xs={12}>
              <Link to="#" className="text-decoration-none">
                <h5 className="display-6" style={{ fontFamily: "math", color: "#347108e0" }}>
                  {!loggedInToken ? "HPTI EXAM PORTAL" : "HPTI"}

                </h5>


                {/* <Marquee text="swetha">Test</Marquee> */}
              </Link>

              {loggedInToken &&
                <Button onClick={toggleSidebar} className="sidebar-toggle ms-3 mb-2" style={{ background: "white" }}>
                  <FontAwesomeIcon icon={isSidebarCollapsed ? faBarsStaggered : faBars} style={{ fontSize: "22px", color: "#17B169" }} />
                </Button>
              }

            </Col>
            <Col className="pt-4" md={6} xs={12}>
              <Navbar light expand="md" id='inner'>
                {!isActive && (
                  <Nav navbar>
                    <NavItem className='me-3'>
                      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                        <DropdownToggle nav caret>
                          <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: '24px', color: '#333' }} />
                          <span className="ml-2 text-dark">&nbsp; {loggedInUserName}</span>
                        </DropdownToggle>
                        <DropdownMenu >
                          <DropdownItem onClick={handleLogout}>
                            <FontAwesomeIcon icon={faRightFromBracket} className="text-danger" /> Logout
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </NavItem>
                  </Nav>
                )}
              </Navbar>
              <Navbar light expand="md">
                {isActive && (
                  <>
                    <NavbarToggler onClick={toggleNavbar} />
                    <Collapse isOpen={isOpen} navbar id='out'>
                      <Nav className="" navbar justify>
                        <NavItem>
                          <Link to="/" className="nav-link font-weight-bold text-dark me-5" style={{ fontWeight: "bolder" }}>
                            <FontAwesomeIcon icon={faHome} style={{ fontSize: "20px" }} />&nbsp; Home
                          </Link>
                        </NavItem>
                        <NavItem>
                          <Link to="/register" onClick={handleRefresh} className="nav-link font-weight-bold text-dark me-5" style={{ fontWeight: "bolder" }}>
                            <FontAwesomeIcon icon={faBook} style={{ fontSize: "20px" }} />
                            <span className="blinking-text ml-2">&nbsp; Register/Login</span>
                          </Link>
                        </NavItem>
                      </Nav>
                    </Collapse>
                  </>
                )}
              </Navbar>
            </Col>
          </Row>

        </div>
        {bannerMessage && (
          <div className='text-center' style={{ background: "" }}>
            <span className="blinking-text">&nbsp; <p className="" style={{ fontFamily: "math", color: "#f21d2b", marginBottom: "0", fontSize: "22px" }}>
              {bannerMessage}
            </p></span>
          </div>
        )}
      </div>
      {logoutSuccess && (
        <div className="alert alert-success text-center mt-3" role="alert">
          You have been successfully logged out.
        </div>
      )}
    </>
  );
};

export default Header;
